/* eslint-disable max-depth */
import { ActiveConfiguration } from '@icc/shared/types';

import { WindowActiveConfiguration } from './window-active-configuration';
import { DoorConfiguration } from './door-configuration';
import { IConfiguratorsDataService } from '@icc/shared/types';
import { BaseColor, Color } from '@icc/construction-elements/types';
import { HardwareVisualization } from '@icc/construction-elements/types';
import { IccAccessoryColor, IccColor, IccSideColors, IccWindowColors, IccWood } from '@icc/construction-elements/types';
import { core } from '@icc/shared/helpers';
import { AppConfig } from '@icc/shared';
import { DoorPanelTrimDto } from '../api/door-panel-trim.dto';
import { DoorHardwareV2 } from '../api/door-hardware.dto';
import { Components } from '../elements/components';
import { HandlesType } from '../elements/handle';
import { Shape } from '../elements/shape';
import { IccFilling } from '../api/filling.dto';
import {
    restoreExplicitFillingColorsInInternalSashes,
} from './restore-explicit-filling-colors';

export class DoorActiveConfiguration extends WindowActiveConfiguration
    implements ActiveConfiguration {
    type: 'door' = 'door';

    Height = 2000;
    Width = 1000;
    Shape: Shape = {
        shape: 'rect',
        width: 1000,
        height: 2000,
        circuit: 6000,
        s1: 1000,
        s2: 0,
        s3: 0,
        h1: 2000,
        h2: 0,
        h3: 2000,
    };
    Factors = {
        thermalTranssmitance: {
            door: null,
            doorLights: {
                left: null,
                right: null,
                top: null,
                total: null
            },
            construction: null
        }
    };


    Model: any | null = null;
    ModelOptions: {
        panelType: 'Inset' | 'Outer' | 'Double' | 'Inner' | 'Mixed';
        panelGlazing: Partial<IccFilling> | null;
        passivePanelGlazing: Partial<IccFilling> | null;
        panelTrim?: Partial<DoorPanelTrimDto> | null;
        innerPanelTrim?: Partial<DoorPanelTrimDto> | null;
        passivePanelTrim?: Partial<DoorPanelTrimDto> | null;
        passiveInnerPanelTrim?: Partial<DoorPanelTrimDto> | null;
        panelInner:
            | Partial<IccFilling> & {
                  selectedColor?: IccSideColors;
                  selectedColorSecond?: IccSideColors;
                  selectedWood?: IccWood;
              }
            | null;
        selectedColor?: Partial<IccSideColors>;
        selectedColorSecond?: Partial<IccSideColors>;
        innerSelectedColor?: Partial<IccSideColors>;
        innerSelectedColorSecond?: Partial<IccSideColors>;
        passiveSelectedColor?: Partial<IccSideColors>;
        passiveSelectedColorSecond?: Partial<IccSideColors>;
        passiveInnerSelectedColor?: Partial<IccSideColors>;
        passiveInnerSelectedColorSecond?: Partial<IccSideColors>;
        passiveSashModel?:
            | Partial<IccFilling> & {
                  selectedColor?: IccSideColors;
                  selectedColorSecond?: IccSideColors;
                  selectedWood?: IccWood;
              }
            | null;
        passiveInnerSashModel?:
            | Partial<IccFilling> & {
                  selectedColor?: IccSideColors;
                  selectedColorSecond?: IccSideColors;
                  selectedWood?: IccWood;
              }
            | null;
        hasBeenChosen: boolean;
        /** Identyfikator wybranego predefiniowanego układu wypełnień */
        predefinedLayoutId?: number;
        /** Nazwa wybranego predefiniowanego układu wypełnień */
        predefinedLayoutName?: string;
        /** Ścieżka obrazu wybranego predefiniowanego układu wypełnień */
        predefinedLayoutImage?: string;
    } = {
        panelType: 'Inset',
        panelGlazing: null,
        passivePanelGlazing: null,
        panelInner: null,
        hasBeenChosen: false,
        predefinedLayoutId: undefined,
        predefinedLayoutName: undefined,
        predefinedLayoutImage: undefined,
    };
    SashesType: 'Fix' | 'FixSash' | 'Func' | 'Mix' = 'Func';
    OwnedSashesTypes = {
        window: false,
        doorActive: true,
        doorPassive: false,
        doorTopLight: false,
        doorLeftLight: false,
        doorRightLight: false,
    };
    destination = '';
    HandleType: HandlesType = 'DoubleLever';

    doorHardwareDictionary: {
        /**
         * Osprzęt drzwi
         */
        doorHardware: Record<DoorHardwareV2['id'], DoorHardwareV2>;
        /**
         * Systemy akcesoriów
         */
        hardwareSystems: Record<DoorHardwareV2['id'], DoorHardwareV2>;
        /**
         * Kolory dodatków (klamek, zawiasów)
         */
        accessoryColors: Record<BaseColor['id'], BaseColor>;
    } = {
        doorHardware: {},
        hardwareSystems: {},
        accessoryColors: {},
    };
    doorHardware: {
        doorHandleAdjustment: null | number;
        type: null | number;
        set: null | 'leverPull' | 'doubleLever' | 'leverKnob' | 'doublePull' | 'innerLever' | 'leverRecessedPull' | 'mixedLever';
        setName: null | string;
        pull: null | number;
        pullColor: null | number;
        pullColorIsDefault: boolean;
        pullColorRelatedToPlate: boolean;
        electronicLock: {
            id: null | number;
            color: null | number;
            colorIsDefault: boolean;
        }
        beaconProximity: boolean;
        color: null | number;
        colorIsDefault: boolean;
        plateType: null | number;
        doorViewer: null | number;
        doorViewerColor: null | number;
        doorViewerColorIsDefault: boolean;
        doorViewerPunching: boolean;
        plates: {
            mainLock: null | number;
            additionalLock: null | number;
            color: null | number;
            colorIsDefault?: boolean;
        };
        outerPlates: {
            mainLock: null | number;
            additionalLock: null | number;
            color: null | number;
            colorIsDefault?: boolean;
        };
        cylinders: {
            mainLock: null | number;
            additionalLock: null | number;
            system: null | number;
            color: null | number;
            mainLockColor: null | number;
            mainLockColorIsDefault: boolean;
            additionalLockColor: null | number;
            additionalLockColorIsDefault: boolean;
            isKeyAvailableForMainLock: null | boolean;
            maxKeyQuantityForMainLock: null | number;
            keyQuantityForMainLock: null | number;
            keyPriceForMainLock: null | number;
            isKeyAvailableForAdditionalLock: null | boolean;
            maxKeyQuantityForAdditionalLock: null | number;
            keyQuantityForAdditionalLock: null | number;
            keyPriceForAdditionalLock: null | number;
        };
        decorativeHingeCovers: null | number;
        decorativeHingeCoversColor: null | number;
        decorativeHingeCoversColorIsDefault: boolean;
        decorativeHingeCoversColorRelatedToPlate: boolean;
        visualizations: {
            pull: HardwareVisualization | null;
            doorViewer: HardwareVisualization | null;
            mainLockPlate: HardwareVisualization | null;
            outerMainLockPlate: HardwareVisualization | null;
            additionalLockPlate: HardwareVisualization | null;
            outerAdditionalLockPlate: HardwareVisualization | null;
            mainLockCylinder: HardwareVisualization | null;
            additionalLockCylinder: HardwareVisualization | null;
            decorativeHingeCovers: HardwareVisualization | null;
            recessedPull: HardwareVisualization | null;
        };
        recessedPull: null | number;
        recessedPullColor: {
            colorSource: string,
            color: IccAccessoryColor | IccColor,
            isDefault: boolean,
            price: number,
            list_price: number,
        } | null;
    } = {
        doorHandleAdjustment: null,
        type: null,
        set: null,
        setName: null,
        pull: null,
        pullColor: null,
        pullColorIsDefault: true,
        pullColorRelatedToPlate: null,
        electronicLock: {
            id: null,
            color: null,
            colorIsDefault: true,
        },
        beaconProximity: false,
        color: null,
        colorIsDefault: true,
        plateType: null,
        doorViewer: null,
        doorViewerColor: null,
        doorViewerColorIsDefault: true,
        doorViewerPunching: false,
        plates: {
            mainLock: null,
            additionalLock: null,
            color: null,
            colorIsDefault: true,
        },
        outerPlates: {
            mainLock: null,
            additionalLock: null,
            color: null,
            colorIsDefault: true,
        },
        cylinders: {
            mainLock: null,
            additionalLock: null,
            system: null,
            color: null,
            mainLockColor: null,
            mainLockColorIsDefault: true,
            additionalLockColor: null,
            additionalLockColorIsDefault: true,
            isKeyAvailableForMainLock: null,
            maxKeyQuantityForMainLock: null,
            keyQuantityForMainLock: null,
            keyPriceForMainLock: null,
            isKeyAvailableForAdditionalLock: null,
            maxKeyQuantityForAdditionalLock: null,
            keyQuantityForAdditionalLock: null,
            keyPriceForAdditionalLock: null,
        },
        decorativeHingeCovers: null,
        decorativeHingeCoversColor: null,
        decorativeHingeCoversColorIsDefault: true,
        decorativeHingeCoversColorRelatedToPlate: false,
        visualizations: {
            pull: null,
            doorViewer: null,
            mainLockPlate: null,
            outerMainLockPlate: null,
            additionalLockPlate: null,
            outerAdditionalLockPlate: null,
            mainLockCylinder: null,
            additionalLockCylinder: null,
            decorativeHingeCovers: null,
            recessedPull: null
        },
        recessedPull: null,
        recessedPullColor: null
    };
    Components: Components = {
        fullDoor: true,
        activeSash: true,
        passiveSash: true,
        frame: true,
        threshold: true,
        hardware: true,
        sideLight: {
            left: true,
            right: true,
            top: true,
        },
        extension: {
            left: true,
            right: true,
            top: true,
        },
        bottomExtension: true,
        portal: true,
        casing: true,
        accessories: true,
        pull: true,
        recessedPull: true,
    };
    // eslint-disable-next-line max-statements
    constructor(
        configuration?,
        configuratorsDataService?: IConfiguratorsDataService,
        langCode = configuration?.langCode || 'pl',
        config: AppConfig = null,
    ) {
        super(configuration, configuratorsDataService, langCode, config);
        if (configuration) {
            if (DoorActiveConfiguration.is(configuration)) {
                for (const propName in configuration) {
                    if (Object.prototype.hasOwnProperty.call(configuration, propName)) {
                        this[propName] = configuration[propName];
                    }
                }
            } else {
                if (DoorConfiguration.is(configuration) && configuratorsDataService) {
                    if (configuration.sashes) {
                        const sashWithDecoPanel = configuration.sashes.find(
                            sash =>
                                sash.filling
                                && ['DRA', 'DOA'].includes(
                                    configuration.dictionary.sashTypes[sash.type.id].type
                                )
                                && (configuration.dictionary.fillings[sash.filling.id].type
                                    === 'deco_panels'
                                    || configuration.dictionary.fillings[sash.filling.id].type
                                        === 'door_panels')
                        );
                        const passiveSashWithDecoPanel = configuration.sashes.find(
                            sash =>
                                sash.type
                                && configuration.dictionary.sashTypes[sash.type.id]
                                && ['DRP', 'DOP'].includes(
                                    configuration.dictionary.sashTypes[sash.type.id].type
                                )
                                && sash.filling
                                && (configuration.dictionary.fillings[sash.filling.id].type
                                    === 'deco_panels'
                                    || configuration.dictionary.fillings[sash.filling.id].type
                                        === 'door_panels')
                        );
                        if (sashWithDecoPanel && sashWithDecoPanel.filling) {
                            this.Model = core.copy(configuratorsDataService.data.fillings.find(e => e.id === sashWithDecoPanel.filling.id))
                                || core.copy(
                                    configuratorsDataService.data.fillings.find(
                                        e => e.id.split('.')[0] === sashWithDecoPanel.filling.id
                                    )
                                )
                                || {}
                            this.Model.selectedColor = !sashWithDecoPanel.filling.color
                                ? null
                                : {
                                    inner: core.copy(configuration.dictionary.colors[
                                        Number(sashWithDecoPanel.filling.color.inner.id)
                                    ]),
                                    outer: core.copy(configuration.dictionary.colors[
                                        Number(sashWithDecoPanel.filling.color.outer.id)
                                    ])
                                  };
                            if (this.Model.selectedColor && sashWithDecoPanel.filling.color) {
                                if (this.Model.selectedColor.inner) {
                                    if (sashWithDecoPanel.filling.color.inner?.isDefault === true) {
                                        this.Model.selectedColor.inner.isDefault = true;
                                    } else {
                                        this.Model.selectedColor.inner.isDefault = false;
                                    }
                                }
                                if (this.Model.selectedColor.outer) {
                                    if (sashWithDecoPanel.filling.color.outer?.isDefault === true) {
                                        this.Model.selectedColor.outer.isDefault = true;
                                    } else {
                                        this.Model.selectedColor.outer.isDefault = false;
                                    }
                                }
                            }

                            this.Model.selectedColorSecond = !sashWithDecoPanel.filling.overlayColor
                                ? null
                                : {
                                    inner: core.copy(configuration.dictionary.colors[
                                        Number(sashWithDecoPanel.filling.overlayColor.inner.id)
                                    ]),
                                    outer: core.copy(configuration.dictionary.colors[
                                        Number(sashWithDecoPanel.filling.overlayColor.outer.id)
                                    ]),
                                  };

                            if (this.Model.selectedColorSecond && sashWithDecoPanel.filling.overlayColor) {
                                if (this.Model.selectedColorSecond.inner) {
                                    if(sashWithDecoPanel.filling.overlayColor.inner?.isDefault === true) {
                                        this.Model.selectedColorSecond.inner.isDefault = true;
                                    } else {
                                        this.Model.selectedColorSecond.inner.isDefault = false;
                                    }
                                }
                                if (this.Model.selectedColorSecond.outer) {
                                    if(sashWithDecoPanel.filling.overlayColor.outer?.isDefault === true) {
                                        this.Model.selectedColorSecond.outer.isDefault = true;
                                    } else {
                                        this.Model.selectedColorSecond.outer.isDefault = false;
                                    }
                                }
                            }


                            this.ModelOptions.panelType = sashWithDecoPanel.panelType || 'Inset';
                            this.ModelOptions.panelGlazing = sashWithDecoPanel.panelGlazing
                                ? configuratorsDataService.get<IccFilling>(
                                      'fillings',
                                      sashWithDecoPanel.panelGlazing.id
                                  ) || null
                                : null;
                            this.ModelOptions.panelTrim = sashWithDecoPanel.panelTrim
                                ? configuratorsDataService.get<DoorPanelTrimDto>(
                                      'doorPanelTrims',
                                      sashWithDecoPanel.panelTrim.id
                                  ) || null
                                : null;
                            if (this.ModelOptions.panelTrim && sashWithDecoPanel.panelTrim?.isDefault != null) {
                                this.ModelOptions.panelTrim.isDefault = sashWithDecoPanel.panelTrim.isDefault;
                            }
                            this.ModelOptions.innerPanelTrim = sashWithDecoPanel.innerPanelTrim
                                ? configuratorsDataService.get<DoorPanelTrimDto>(
                                      'doorPanelTrims',
                                      sashWithDecoPanel.innerPanelTrim.id
                                  ) || null
                                : null;
                            if (this.ModelOptions.innerPanelTrim && sashWithDecoPanel.innerPanelTrim?.isDefault != null) {
                                this.ModelOptions.innerPanelTrim.isDefault = sashWithDecoPanel.innerPanelTrim.isDefault;
                            }

                            this.ModelOptions.panelInner = sashWithDecoPanel.panelInner
                                ? core.copy(configuratorsDataService.data.fillings.find(e => Number(e.id) === Number(sashWithDecoPanel.panelInner.id)))
                                    || core.copy(
                                        configuratorsDataService.data.fillings.find(
                                            e => Number(e.id.split('.')[0]) === Number(sashWithDecoPanel.panelInner.id)
                                        )
                                    ) || null
                                : null;
                            if (this.ModelOptions.panelInner) {
                                this.ModelOptions.panelInner.selectedColor =
                                    !sashWithDecoPanel.panelInner || !sashWithDecoPanel.panelInner.color
                                        ? null
                                        : {
                                            inner: this.convertName(configuration.dictionary.colors[
                                                Number(sashWithDecoPanel.panelInner.color.inner.id)
                                            ] as Color),
                                            outer: this.convertName(configuration.dictionary.colors[
                                                Number(sashWithDecoPanel.panelInner.color.outer.id)
                                            ] as Color),
                                        };
                                if (this.ModelOptions.panelInner.selectedColor && sashWithDecoPanel.panelInner.color) {
                                    if (this.ModelOptions.panelInner.selectedColor.inner) {
                                        if(sashWithDecoPanel.panelInner.color.inner?.isDefault === true) {
                                            this.ModelOptions.panelInner.selectedColor.inner.isDefault = true;
                                        } else {
                                            this.ModelOptions.panelInner.selectedColor.inner.isDefault = false;
                                        }
                                    }
                                    if (this.ModelOptions.panelInner.selectedColor.outer) {
                                        if(sashWithDecoPanel.panelInner.color.outer?.isDefault === true) {
                                            this.ModelOptions.panelInner.selectedColor.outer.isDefault = true;
                                        } else {
                                            this.ModelOptions.panelInner.selectedColor.outer.isDefault = false;
                                        }
                                    }
                                }


                                this.ModelOptions.panelInner.selectedColorSecond =
                                    !sashWithDecoPanel.panelInner
                                    || !sashWithDecoPanel.panelInner.overlayColor
                                        ? null
                                        : {
                                            inner: this.convertName(configuration.dictionary.colors[
                                                Number(sashWithDecoPanel.panelInner.overlayColor.inner.id)
                                            ] as Color),
                                            outer: this.convertName(configuration.dictionary.colors[
                                                Number(sashWithDecoPanel.panelInner.overlayColor.outer.id)
                                            ] as Color),
                                        };

                                if (this.ModelOptions.panelInner.selectedColorSecond && sashWithDecoPanel.panelInner.overlayColor) {
                                    if (this.ModelOptions.panelInner.selectedColorSecond.inner) {
                                        if(sashWithDecoPanel.panelInner.overlayColor.inner?.isDefault === true) {
                                            this.ModelOptions.panelInner.selectedColorSecond.inner.isDefault = true;
                                        } else {
                                            this.ModelOptions.panelInner.selectedColorSecond.inner.isDefault = false;
                                        }
                                    }
                                    if (this.ModelOptions.panelInner.selectedColorSecond.outer) {
                                        if( sashWithDecoPanel.panelInner.overlayColor.outer?.isDefault === true) {
                                            this.ModelOptions.panelInner.selectedColorSecond.outer.isDefault = true;
                                        } else {
                                            this.ModelOptions.panelInner.selectedColorSecond.outer.isDefault = false;
                                        }
                                    }
                                }
                            }
                            this.ModelOptions.selectedColor =
                                this.Model.selectedColor;
                            this.ModelOptions.selectedColorSecond =
                                this.Model.selectedColorSecond;

                            this.ModelOptions.innerSelectedColor =
                                core.copy(this.ModelOptions.panelInner
                                && this.ModelOptions.panelInner.selectedColor);
                            delete this.ModelOptions?.panelInner?.selectedColor;

                            this.ModelOptions.innerSelectedColorSecond =
                                core.copy(this.ModelOptions.panelInner
                                && this.ModelOptions.panelInner.selectedColorSecond);
                            delete this.ModelOptions?.panelInner?.selectedColorSecond;
                        }
                        if (passiveSashWithDecoPanel && passiveSashWithDecoPanel.filling) {
                            this.ModelOptions.passiveSashModel = configuratorsDataService.get(
                                'fillings',
                                sashWithDecoPanel.filling.id
                            );
                            this.ModelOptions.passiveSashModel.selectedColor = !passiveSashWithDecoPanel
                                .filling.color
                                ? null
                                : {
                                    inner: this.convertName(
                                        configuration.dictionary.colors[
                                            Number(passiveSashWithDecoPanel.filling.color.inner.id)
                                        ] as Color
                                    ),
                                    outer: this.convertName(
                                        configuration.dictionary.colors[
                                            Number(passiveSashWithDecoPanel.filling.color.outer.id)
                                        ] as Color
                                    ),
                                };

                            if (this.ModelOptions.passiveSashModel.selectedColor && passiveSashWithDecoPanel.filling.color) {
                                if (this.ModelOptions.passiveSashModel.selectedColor.inner) {
                                    if(passiveSashWithDecoPanel.filling.color.inner?.isDefault === true) {
                                        this.ModelOptions.passiveSashModel.selectedColor.inner.isDefault = true;
                                    } else {
                                        this.ModelOptions.passiveSashModel.selectedColor.inner.isDefault = false;
                                    }
                                }
                                if (this.ModelOptions.passiveSashModel.selectedColor.outer) {
                                    if(passiveSashWithDecoPanel.filling.color.outer?.isDefault === true) {
                                        this.ModelOptions.passiveSashModel.selectedColor.outer.isDefault = true;
                                    } else {
                                        this.ModelOptions.passiveSashModel.selectedColor.outer.isDefault = false;
                                    }
                                }
                            }

                            this.ModelOptions.passiveSashModel.selectedColorSecond = !passiveSashWithDecoPanel
                                .filling.overlayColor
                                ? null
                                : {
                                    inner: this.convertName(
                                        configuration.dictionary.colors[
                                          Number(passiveSashWithDecoPanel.filling.overlayColor.inner.id)
                                        ] as Color
                                    ),
                                    outer: this.convertName(
                                        configuration.dictionary.colors[
                                          Number(passiveSashWithDecoPanel.filling.overlayColor.outer.id)
                                        ] as Color
                                    ),
                                };

                            if (this.ModelOptions.passiveSashModel.selectedColorSecond && passiveSashWithDecoPanel.filling.overlayColor) {
                                if (this.ModelOptions.passiveSashModel.selectedColorSecond.inner) {
                                    if(passiveSashWithDecoPanel.filling.overlayColor.inner?.isDefault === true) {
                                        this.ModelOptions.passiveSashModel.selectedColorSecond.inner.isDefault = true;
                                    } else {
                                        this.ModelOptions.passiveSashModel.selectedColorSecond.inner.isDefault = false;
                                    }
                                }
                                if (this.ModelOptions.passiveSashModel.selectedColorSecond.outer) {
                                    if( passiveSashWithDecoPanel.filling.overlayColor.outer?.isDefault === true) {
                                        this.ModelOptions.passiveSashModel.selectedColorSecond.outer.isDefault = true;
                                    } else {
                                        this.ModelOptions.passiveSashModel.selectedColorSecond.outer.isDefault = false;
                                    }
                                }
                            }

                            this.ModelOptions.passivePanelGlazing = passiveSashWithDecoPanel.panelGlazing
                                ? configuratorsDataService.get<IccFilling>(
                                    'fillings',
                                    passiveSashWithDecoPanel.panelGlazing.id
                                ) || null
                                : null;

                            this.ModelOptions.passivePanelTrim = passiveSashWithDecoPanel.panelTrim
                                ? configuratorsDataService.get<DoorPanelTrimDto>(
                                    'doorPanelTrims',
                                    passiveSashWithDecoPanel.panelTrim.id
                                ) || null
                                : null;
                            if (this.ModelOptions.passivePanelTrim && passiveSashWithDecoPanel.panelTrim?.isDefault != null) {
                                this.ModelOptions.passivePanelTrim.isDefault = passiveSashWithDecoPanel.panelTrim.isDefault;
                            }

                            this.ModelOptions.passiveInnerPanelTrim = passiveSashWithDecoPanel.innerPanelTrim
                                ? configuratorsDataService.get<DoorPanelTrimDto>(
                                    'doorPanelTrims',
                                    passiveSashWithDecoPanel.innerPanelTrim.id
                                ) || null
                                : null;
                            if (this.ModelOptions.passiveInnerPanelTrim && passiveSashWithDecoPanel.innerPanelTrim?.isDefault != null) {
                                this.ModelOptions.passiveInnerPanelTrim.isDefault = passiveSashWithDecoPanel.innerPanelTrim.isDefault;
                            }

                            if(sashWithDecoPanel.panelInner) {
                                this.ModelOptions.passiveInnerSashModel = configuratorsDataService.get(
                                   'fillings',
                                   sashWithDecoPanel.panelInner.id
                               );
                               this.ModelOptions.passiveInnerSashModel.selectedColor = !passiveSashWithDecoPanel
                                   .panelInner.color
                                   ? null
                                   : {
                                       inner: this.convertName(
                                           configuration.dictionary.colors[
                                               Number(passiveSashWithDecoPanel.panelInner.color.inner.id)
                                           ] as Color
                                       ),
                                       outer: this.convertName(
                                           configuration.dictionary.colors[
                                               Number(passiveSashWithDecoPanel.panelInner.color.outer.id)
                                           ] as Color
                                       ),
                                   };

                                   if (this.ModelOptions.passiveInnerSashModel.selectedColor && passiveSashWithDecoPanel.panelInner.color) {
                                    if (this.ModelOptions.passiveInnerSashModel.selectedColor.inner) {
                                        if(passiveSashWithDecoPanel.panelInner.color.inner?.isDefault === true) {
                                            this.ModelOptions.passiveInnerSashModel.selectedColor.inner.isDefault = true;
                                        } else {
                                            this.ModelOptions.passiveInnerSashModel.selectedColor.inner.isDefault = false;
                                        }
                                    }
                                    if (this.ModelOptions.passiveInnerSashModel.selectedColor.outer) {
                                        if(passiveSashWithDecoPanel.panelInner.color.outer?.isDefault === true) {
                                            this.ModelOptions.passiveInnerSashModel.selectedColor.outer.isDefault = true;
                                        } else {
                                            this.ModelOptions.passiveInnerSashModel.selectedColor.outer.isDefault = false;
                                        }
                                    }
                                }

                                this.ModelOptions.passiveInnerSashModel.selectedColorSecond = !passiveSashWithDecoPanel
                                .panelInner.overlayColor
                                ? null
                                : {
                                    inner: this.convertName(
                                        configuration.dictionary.colors[
                                          Number(passiveSashWithDecoPanel.panelInner.overlayColor.inner.id)
                                        ] as Color
                                    ),
                                    outer: this.convertName(
                                        configuration.dictionary.colors[
                                          Number(passiveSashWithDecoPanel.panelInner.overlayColor.outer.id)
                                        ] as Color
                                    ),
                                };

                                if (this.ModelOptions.passiveInnerSashModel.selectedColorSecond && passiveSashWithDecoPanel.panelInner.overlayColor) {
                                    if (this.ModelOptions.passiveInnerSashModel.selectedColorSecond.inner) {
                                        if(passiveSashWithDecoPanel.panelInner.overlayColor.inner?.isDefault === true) {
                                            this.ModelOptions.passiveSashModel.selectedColorSecond.inner.isDefault = true;
                                        } else {
                                            this.ModelOptions.passiveSashModel.selectedColorSecond.inner.isDefault = false;
                                        }
                                    }
                                    if (this.ModelOptions.passiveInnerSashModel.selectedColorSecond.outer) {
                                        if(passiveSashWithDecoPanel.panelInner.overlayColor.outer?.isDefault === true) {
                                            this.ModelOptions.passiveInnerSashModel.selectedColorSecond.outer.isDefault = true;
                                        } else {
                                            this.ModelOptions.passiveInnerSashModel.selectedColorSecond.outer.isDefault = false;
                                        }
                                    }
                                }
                            }

                            this.ModelOptions.passiveSelectedColor =
                                core.copy(this.ModelOptions.passiveSashModel.selectedColor);
                            delete this.ModelOptions?.passiveSashModel?.selectedColor;

                            this.ModelOptions.passiveSelectedColorSecond =
                                core.copy(this.ModelOptions.passiveSashModel.selectedColorSecond);
                            delete this.ModelOptions?.passiveSashModel?.selectedColorSecond;

                            this.ModelOptions.passiveInnerSelectedColor =
                                core.copy(this.ModelOptions.passiveInnerSashModel.selectedColor);
                            delete this.ModelOptions?.passiveInnerSashModel?.selectedColor;

                            this.ModelOptions.passiveInnerSelectedColorSecond =
                                core.copy(this.ModelOptions.passiveInnerSashModel.selectedColorSecond);
                            delete this.ModelOptions?.passiveInnerSashModel?.selectedColorSecond;
                        }
                    }
                    let doorFrameAndSashShortening = 0
                    if(this.doorSizes.shortening > 0) {
                        doorFrameAndSashShortening = Math.abs(this.doorSizes.shortening - this.doorSizes.frameShortening);
                    }
                    this.Height = configuration.height - doorFrameAndSashShortening;
                    this.SashesType = configuration.sashesType;
                    this.Width = configuration.width;
                    this.HandleType = configuration.handleType;
                    this.OwnedSashesTypes = configuration.ownedSashesTypes;
                    this.Shape = configuration.shape;
                    ([
                        'height',
                        'h1',
                        'h2',
                        'h3',
                    ] as const).forEach((field) => {
                        if (this.Shape[field] != null && this.Shape[field] !== 0) {
                            this.Shape[field] -= Number(doorFrameAndSashShortening);
                        }
                    });
                    this.doorHardware = configuration.doorHardware;
                    this.doorHardwareDictionary.doorHardware =
                        configuration.dictionary.doorHardware;
                    this.doorHardwareDictionary.hardwareSystems =
                        configuration.dictionary.hardwareSystems;
                    this.doorHardwareDictionary.accessoryColors =
                        configuration.dictionary.accessoryColors;
                    this.Components = configuration.components;
                    if(configuration.slat) {
                        const selectedSlat = configuratorsDataService.data.slats.find(slat => slat.id === configuration.slat.id);
                        this.Slat = {
                            id: configuration.slat.id,
                            name: configuration.slat.name,
                            extId: configuration.slat.extId,
                            indexNo: configuration.slat.index_no,
                            image: configuration.slat.image,
                            defaultColorGroupId: selectedSlat?.defaultColorGroupId || null,
                            defaultColorId: selectedSlat?.defaultColorId || null,
                            topOffset: configuration.slat.topOffset,
                            bottomOffset: configuration.slat.bottomOffset,
                            innerHingeOffset: configuration.slat.innerHingeOffset,
                            outerHingeOffset: configuration.slat.outerHingeOffset,
                            space: configuration.slat.space,
                            width: configuration.slat.width,
                            colorGroups: selectedSlat?.colorGroups || [],
                            count: configuration.slat.count
                        }
                        this.SlatColor = configuration.slat.slatColor;
                    }
                    restoreExplicitFillingColorsInInternalSashes(this.Sashes);
                }
                // Przywróć dane predefiniowanego układu wypełnień — nie są odtwarzane
                // przez logikę sash, więc musimy je skopiować bezpośrednio z modelOptions.
                if (configuration.modelOptions?.predefinedLayoutId != null) {
                    this.ModelOptions.predefinedLayoutId = configuration.modelOptions.predefinedLayoutId;
                    this.ModelOptions.predefinedLayoutName = configuration.modelOptions.predefinedLayoutName;
                    this.ModelOptions.predefinedLayoutImage = configuration.modelOptions.predefinedLayoutImage;
                }
            }
        }
    }

    public static is(configuration: any): configuration is DoorActiveConfiguration {
        return (
            configuration instanceof DoorActiveConfiguration
            || (!configuration.$version && configuration.type === 'door')
        );
    }
}
